<script lang="ts" setup>
import type { InputHTMLAttributes } from 'vue';

interface Props extends /* @vue-ignore */ InputHTMLAttributes {
  value: string | number;
  name: string;
  size?: 's' | 'm';
  dark?: boolean;
  classic?: boolean;
  tag?: string;
}

defineOptions({ inheritAttrs: false });
withDefaults(defineProps<Props>(), { size: 'm' });
const checked = defineModel<boolean>('checked', {
  default: false,
});
const attrs = useAttrs();

const inputAttrs = computed(() => {
  const { class: _, ...rest } = attrs;
  return rest;
});
</script>

<template>
  <label
    class="baseRadio"
    :class="[
      {
        [`baseRadio_${size}`]: true,
        baseRadio_dark: dark,
        baseRadio_classic: classic,
      },
      attrs.class,
    ]"
  >
    <input
      @change="checked = !checked"
      :checked="checked"
      :value="value"
      :name="name"
      type="radio"
      v-bind="inputAttrs"
      class="baseRadio__input"
    />
    <span class="baseRadio__box">
      <SvgoSimpleCheck class="baseRadio__check" />
    </span>
  </label>
</template>

<style lang="scss">
.baseRadio {
  $self: &;

  width: fit-content;
  height: fit-content;
  display: block;
  cursor: pointer;

  &_s {
    #{$self}__box {
      width: 16px;
      height: 16px;
    }

    #{$self}__check {
      width: 12px;
      height: 12px;
    }
  }

  &_dark {
    #{$self}__check {
      color: #fff;
    }

    #{$self}__input:checked + #{$self}__box {
      border-color: #121212;
      background-color: #121212;
    }
  }

  &_classic {
    #{$self}__box {
      border-radius: 4px;
      border-color: rgba(0, 0, 0, 0.1);
    }

    #{$self}__input:checked + #{$self}__box {
      border-color: rgba(0, 0, 0, 0.1);
    }
  }

  &__input {
    @include visibility-hidden;
  }

  &__box {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #121212;
    border-radius: 50%;
    transition:
      border-color 0.3s ease,
      background-color 0.3s ease;
    background-color: #fff;
  }

  &__check {
    width: 18px;
    height: 18px;
    display: block;
    clip-path: inset(0 100% 0 0);
    transition: clip-path 0.3s ease;
    color: #121212;
  }

  &__input:checked {
    & + #{$self}__box {
      border-color: #fff;

      #{$self}__check {
        clip-path: inset(0 0 0 0);
      }
    }
  }
}
</style>
